import React from "react";
import Navbar from "../Components/Navbar";
import Mainhero from "../AllCart/Mainhero";
import Footer from "../Components/Footer";
import Thankcontent from "./Thankcontent";
import { CartProvider } from "react-use-cart";
function Thankyou() {
  return (
    <CartProvider>
      <Navbar />
      <Mainhero value={<h1>Cart</h1>} />
      <Thankcontent />
      <Footer />
    </CartProvider>
  );
}

export default Thankyou;
